import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useAddWishlistProductVariant, useRemoveWishlistProductVariant, useUserWishlist } from "@sdk/react";
import React, { useCallback } from "react";
import { WishlistContext } from "./context";
var WHISHLIST_ITEMS_PER_API_CALL = 100;
var initialWishlistVariables = {
  first: WHISHLIST_ITEMS_PER_API_CALL
};
export function WishlistProvider(_ref) {
  var children = _ref.children;

  var _useUserWishlist = useUserWishlist(initialWishlistVariables),
      data = _useUserWishlist.data,
      loading = _useUserWishlist.loading,
      error = _useUserWishlist.error,
      loadMore = _useUserWishlist.loadMore,
      refetch = _useUserWishlist.refetch;

  var _useAddWishlistProduc = useAddWishlistProductVariant(),
      _useAddWishlistProduc2 = _slicedToArray(_useAddWishlistProduc, 2),
      add = _useAddWishlistProduc2[0],
      _useAddWishlistProduc3 = _useAddWishlistProduc2[1],
      addLoading = _useAddWishlistProduc3.loading,
      addError = _useAddWishlistProduc3.error;

  var _useRemoveWishlistPro = useRemoveWishlistProductVariant(),
      _useRemoveWishlistPro2 = _slicedToArray(_useRemoveWishlistPro, 2),
      remove = _useRemoveWishlistPro2[0],
      _useRemoveWishlistPro3 = _useRemoveWishlistPro2[1],
      removeLoading = _useRemoveWishlistPro3.loading,
      removeError = _useRemoveWishlistPro3.error;

  React.useEffect(function () {
    if (data && data.pageInfo.hasNextPage) {
      loadMore({
        after: data.pageInfo.endCursor
      });
    }
  }, [data]);
  var update = useCallback(function () {
    refetch();
  }, [refetch]);
  var addWishlistProductVariant = useCallback(function (variables) {
    var p = add(variables);
    update();
    return p;
  }, [add, update]);
  var removeWishlistProductVariant = useCallback(function (variables) {
    var p = remove(variables);
    update();
    return p;
  }, [remove, update]);
  return React.createElement(WishlistContext.Provider, {
    value: {
      addError: addError,
      addLoading: addLoading,
      addWishlistProductVariant: addWishlistProductVariant,
      error: error,
      loading: loading,
      removeError: removeError,
      removeLoading: removeLoading,
      removeWishlistProductVariant: removeWishlistProductVariant,
      wishlist: data && data.edges.map(function (_ref2) {
        var node = _ref2.node;
        return node;
      })
    }
  }, children);
}